<template>
<v-dialog v-model="dialog" width="60%" persistent>
 <v-card v-if="currentChat" class="event-form pb-2">
  <v-card-title class="p-3 mb-5" color="primary">
    <v-icon class="mr-3" @click="close">
      mdi-close
    </v-icon>
    <b>{{ user.id === currentChat.staffUser?.id ? 'Your chat history' : `${currentChat.staffUser?.name ?? $t('FamilyView.NullUser')} history` }}</b>
  </v-card-title>

  <v-card-text style="flex: 1 1 auto; overflow-y: auto; height: 100%;">
    <v-tabs v-model="tab" left vertical style="height: 100%;">
      <v-tab v-for="(chat, index) in chats" :key="index">
        <v-avatar size="30px" class="mr-2">
          <img v-if="chat.staffUser?.image" :src="chat.staffUser.image" alt="no avatar" />
        </v-avatar>
        <span class="current-user-name" v-if="user.id === chat.staffUser?.id">You</span>
        <span v-else>{{ chat.staffUser?.name ?? $t('FamilyView.NullUser') }}</span>
      </v-tab>
      <v-tab-item v-for="(chat, index) in chats" :key="'item-' + index">
        <v-card flat>
          <ChatPanel :data="{familyMember: currentChat.familyUser, isReadOnly: true, maxHeight: '620px', channel: currentChat.channel}" />
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card-text>

  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn class="primary" @click="close">
      {{ $t('GeneralTranslations.Close') }}
    </v-btn>
  </v-card-actions>
</v-card>

</v-dialog>
</template>

<script>
import ChatPanel from '@/components/chat/ChatPanel.vue'

export default {
  name: "FamilyStaffChatHistoryDialog",
  components: {
    ChatPanel
  },
  data() {
    return {
      dialog: false,
      tab: 0
    };
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    chats() {
      return this.$store.state.messagesModule.familyMemberStaffChats;
    },
    currentChat() {
      return this.chats[this.tab] || null;
    },
    currentChatMessages() {
      return this.allFamilyMessages.filter(m => m.channel === this.currentChat.channel);
    },
    allFamilyMessages() {
      return this.$store.state.messagesModule.familyMessages;
    },
    user() {
      return this.$store.state.authModule.user;
    }
  },
  methods: {
    async open(chat) {
      this.dialog = true;
      const index = this.chats.findIndex(c => c.id === chat.id);
      this.tab = index !== -1 ? index : 0;
      await this.$store.dispatch("getFamilyMessages", { familyId: chat.familyUser.id, duration: null });
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>

<style scoped>

::v-deep .v-card{
  box-shadow: none !important;
}

.v-card{
  box-shadow: none !important;
}

.my-tabs .v-tab {
  cursor: pointer;
}

.current-user-name{
  font-family: 28px;
  font-weight: bold;
}

::v-deep .v-slide-group__wrapper{
  min-width: 250px;
}

.event-form {
  height: 760px;
  display: flex; 
  flex-direction: column;
}

::v-deep .v-card { 
 box-shadow: none!important;
}
</style>